/* global location */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './gbi-home.scss';
import GoodBeefScale from '../util/figures/GoodBeefScale';
import GBIButton from '../util/buttons/components/GBIButton';
import GBIVennConcept from '../util/figures/GBIVennConcept';
import QRCode from 'qrcode.react';
import { Helmet } from 'react-helmet';
import VennDiagramDefs from '../util/figures/VennDiagramDefs';
import GoodBeefHomePageSection from './GoodBeefHomePageSection';
import InfoIconThick from '../util/icons/components/InfoIconThick';
// import debounce from '../util/debounce';

const sectionIds = ['top', 'what', 'price', 'how', 'example', 'why'];

export const exampleLink = '/animal/61656b896c56a46b0f000010?example=true';

class GBIHome extends Component {
  constructor (props) {
    super(props);
    this.state = {
      currentlyShowing: 'top'
    };
    this.scrollToSection = this.scrollToSection.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.betterScrollHandler = this.betterScrollHandler.bind(this);
  }
  betterScrollHandler () {
    const now = window.performance.now();
    if (!this.scrollCaughtTime) {
      this.scrollCaughtTime = now;
      const handle = this.handleScroll.bind(this);
      const that = this;
      this.handleScrollTimeout = setTimeout(() => {
        handle();
        delete that.scrollCaughtTime;
      }, 100);
    }
  }
  componentDidMount () {
    window.scroll({ top: 0, left: 0, behavior: 'auto' });
    this.calculateScrollPoints();
    window.addEventListener('resize', this.calculateScrollPoints.bind(this));
    window.addEventListener('scroll', this.betterScrollHandler);
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.calculateScrollPoints.bind(this));
    window.removeEventListener('scroll', this.betterScrollHandler);
  }
  calculateScrollPoints () {
    const scrollPoints = [];
    let requiresAdjustment = false;
    sectionIds.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        const boundingRect = element.getBoundingClientRect();
        scrollPoints.push({
          id,
          top: boundingRect.top,
          bottom: boundingRect.top + boundingRect.height
        });
        if (boundingRect.top < 0) requiresAdjustment = true;
      }
    });
    if (requiresAdjustment) {
      let adjustment = 0;
      const price = document.getElementById('price');
      if (price) {
        adjustment = price.getBoundingClientRect().top;
      }
      scrollPoints.forEach(point => {
        point.top = point.top - adjustment;
        point.bottom = point.bottom - adjustment;
      });
    }
    this.scrollPoints = scrollPoints;
  }
  scrollToSection (sectionId) {
    document.getElementById(sectionId).scrollIntoView({
      behavior: 'smooth'
    });
  }
  handleScroll () {
    // const start = window.performance.now();
    const top = window.scrollY;
    const bottom = top + window.innerHeight;
    let currentSection = null;
    let currentSectionInView = 0;
    this.scrollPoints.forEach(scrollPoint => {
      let visiblePixels = 0;
      // console.log(scrollPoint.id);
      // console.log(`screen top - ${scrollPoint.top} < ${top} < ${scrollPoint.bottom} : ${top > scrollPoint.top && top < scrollPoint.bottom}`); /* eslint-disable-line */
      // console.log(`screen bottom - ${scrollPoint.top} < ${bottom} < ${scrollPoint.bottom} : ${bottom > scrollPoint.top && bottom < scrollPoint.bottom}`); /* eslint-disable-line */
      if (
        // top in between scrollPoint.top && scrollPoint.bottom
        top >= scrollPoint.top && top <= scrollPoint.bottom
      ) {
        const base = bottom < scrollPoint.bottom ? bottom : scrollPoint.bottom;
        visiblePixels = base - top;
      } else if (
        // bottom in between scrollPoint.top && scrollPoint.bottom
        (bottom >= scrollPoint.top && bottom <= scrollPoint.bottom)
      ) {
        const upper = top > scrollPoint.top ? top : scrollPoint.top;
        visiblePixels = bottom - upper;
      }
      if (visiblePixels > currentSectionInView || !currentSection) {
        currentSection = scrollPoint.id;
        currentSectionInView = visiblePixels;
      }
    });
    // console.log('-----setSectionInView-----', currentSection);
    if (currentSection !== this.state.currentlyShowing) {
      this.setState({
        currentlyShowing: currentSection
      });
    }
    // const end = window.performance.now();
    // console.log(`------handle scroll ${end - start}ms-------`);
  }
  renderMenu () {
    const items = sectionIds.map(item => {
      let className = 'progress-menu-item';
      if (item === this.state.currentlyShowing) className += ' active';
      return (
        <li className={ className }
          onClick={ () => this.scrollToSection(item) }
          data-cy={ 'progress-menu-item-' + item }
          key={ item }>
          <div className="inner"></div>
        </li>
      );
    });
    return (
      <ul className="progress-menu">
        { items }
      </ul>
    );
  }
  render () {
    const meta = 'the GoodBeef Index measures and grades beef quality. ' +
      'Find out everything you need to know about the meat you eat';
    return (
      <div id="home">
        <VennDiagramDefs />
        <Helmet>
          <title>
            GoodBeef Index Quality Grading System. Good Beef is Good for You
          </title>
          <meta name="description" content={ meta } />
          <link rel="canonical" href="http://goodbeefindex.org" />
        </Helmet>
        { this.renderMenu() }
        <section id="top"
          data-cy="home-page-top-section"
          className="home-page-section">
          <GoodBeefHomePageSection />
        </section>
        <section
          data-cy="home-page-venn-section"
          id="what"
          className="home-page-section grey">
          <h2>
            <span>how does the GoodBeef Index </span>
            <Link to="/about/scoring">
              <span className="highlight">
                measure quality?<InfoIconThick />
              </span>
            </Link>
          </h2>
          <GBIVennConcept score={ 110 } view='concept' />
        </section>
        <section
          id="price" className="home-page-section gbi-content">
          <h1 className="starter">a fair price...</h1>
          <h1 className="punchline">
            <Link to="/about/fair-prices">
              for an authenticated grade of quality
              <InfoIconThick />
            </Link>
          </h1>
          <GBIButton onClick={ () => this.scrollToSection('how')}
            className="next-button"
            label="show me the grades" />
        </section>
        <section
          data-cy="home-page-grade-section"
          id="how"
          className="home-page-section grey">
          <h2>
            <span>what are the </span>
            <Link to="/about/fair-prices">
              <span className="highlight">
                GoodBeef Index grades?
                <InfoIconThick />
              </span>
            </Link>
          </h2>
          <GoodBeefScale score={110} />
        </section>
        <section
          id="example" className="home-page-section">
          <h1 className="starter">see it in action...</h1>
          <h1 className="punchline">
            { `We took a top tier animal and scored it 
            against the index` }
          </h1>
          <div className="options-section">
            <Link to={ exampleLink }>
              <GBIButton label="view example"/>
            </Link>
            <h2 className="option">or scan our QR Code link...</h2>
            <div className="qr-code-wrapper">
              <Link to={ exampleLink }>
                <QRCode
                  size={ 160 }
                  value={`${location.protocol}//${location.host}${exampleLink}`}
                  renderAs='svg'/>
              </Link>
              <Link to="/about/qr-codes"><InfoIconThick /></Link>
            </div>
          </div>
        </section>
        <section
          id="why" className="home-page-section grey">
          <h1 className="starter">why is it important?</h1>
          <h1 className="punchline">
            the GoodBeef Index brings together the farmer and the consumer
          </h1>
          <div className="options-section">
            <Link to="/rate-my-animal"><GBIButton label="try it out"/></Link>
          </div>
        </section>
      </div>
    );
  }
}

export default GBIHome;
